/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Theme } from "@mui/material/styles";

export default function Accordion(theme: Theme): any {
  return {
    MuiAccordion: {
      styleOverrides: {
        root: {
          "&:before": { display: "none" },
          "&.Mui-expanded": { boxShadow: theme.customShadows.z1, borderRadius: theme.shape.borderRadius, margin: 0 },
          "&.Mui-disabled": { backgroundColor: "transparent" },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          paddingLeft: theme.spacing(2),
          paddingRight: theme.spacing(2),
          "&.Mui-disabled": {
            opacity: 1,
            color: theme.palette.action.disabled,
            "& .MuiTypography-root": { color: "inherit" },
          },
        },
        expandIconWrapper: { color: "inherit" },
      },
    },
  };
}
